/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RoleResource } from '../models/RoleResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RoleService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lister les roles
     * Les roles Lol@pp attribuables aux personnels (commercial, metreur, technicien, directeur commercial...).
     * @param sortBy
     * @param sortDesc
     * @returns RoleResource Array of `RoleResource`
     * @throws ApiError
     */
    public adminRolesIndex(
        sortBy?: string,
        sortDesc?: boolean,
    ): CancelablePromise<Array<RoleResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/roles',
            query: {
                'sortBy': sortBy,
                'sortDesc': sortDesc,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Creer un role
     * @param requestBody
     * @returns RoleResource `RoleResource`
     * @throws ApiError
     */
    public adminRolesStore(
        requestBody: {
            name: string;
            permission?: string;
        },
    ): CancelablePromise<RoleResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/roles',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un role
     * @param id
     * @returns RoleResource `RoleResource`
     * @throws ApiError
     */
    public adminRolesShow(
        id: number,
    ): CancelablePromise<RoleResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/roles/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Modifier un role
     * Mise a jour partielle.
     * @param id
     * @returns RoleResource `RoleResource`
     * @throws ApiError
     */
    public adminRolesUpdate(
        id: string,
    ): CancelablePromise<RoleResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/admin/roles/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Supprimer un role
     * Les personnels qui le portaient le perdent.
     * @param id
     * @returns any
     * @throws ApiError
     */
    public adminRolesDestroy(
        id: string,
    ): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/roles/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
